import { Link } from 'react-router-dom';
import { useDocumentTitle } from '@/hooks';
import { AuthPanel, LoginForm } from '../components';
import { AUTH_ROUTES } from '../constants';

export function LoginPage() {
  useDocumentTitle('Entrar');

  return (
    <>
      <AuthPanel>
        <LoginForm />
      </AuthPanel>

      {/* No celular a conta nova desce para o rodape, como em aplicativo: e
          saida, nao parte do formulario. */}
      <p className="mt-auto pt-10 text-center text-sm text-muted-foreground sm:mt-0 sm:pt-6">
        Ainda nao tem conta?{' '}
        <Link to={AUTH_ROUTES.REGISTER} className="font-medium text-primary hover:underline">
          Criar conta
        </Link>
      </p>
    </>
  );
}
